import React, { useState, useEffect } from "react";
import {
  Box,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

// Пример данных
const timeSlots = [
  { id: 1, day_id: 0, day: "Понедельник", time: "8:00-9:30" },
  { id: 2, day_id: 0, time: "9:40-11:20" },
  { id: 3, day_id: 0, time: "11:40-13:20" },
  { id: 4, day_id: 0, time: "13:30-15:00" },
  { id: 5, day_id: 1, day: "Вторник", time: "8:00-9:30" },
  { id: 6, day_id: 1, time: "9:40-11:20" },
  { id: 7, day_id: 1, time: "11:40-13:20" },
  { id: 8, day_id: 1, time: "13:30-15:00" },
  { id: 9, day_id: 2, day: "Среда", time: "8:00-9:30" },
  { id: 10, day_id: 2, time: "9:40-11:20" },
  { id: 11, day_id: 2, time: "11:40-13:20" },
  { id: 12, day_id: 2, time: "13:30-15:00" },
  { id: 13, day_id: 3, day: "Четверг", time: "8:00-9:30" },
  { id: 14, day_id: 3, time: "9:40-11:20" },
  { id: 15, day_id: 3, time: "11:40-13:20" },
  { id: 16, day_id: 3, time: "13:30-15:00" },
  { id: 17, day_id: 4, day: "Пятница", time: "8:00-9:30" },
  { id: 18, day_id: 4, time: "9:40-11:20" },
  { id: 19, day_id: 4, time: "11:40-13:20" },
  { id: 20, day_id: 4, time: "13:30-15:00" },
];

export default function Schedules() {
  const [groups, setGroups] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [offices, setOffices] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [scheduleData, setScheduleData] = useState({});

  useEffect(() => {
    // Пример данных (можно заменить на запросы к API)
    setGroups([
      { id: 1, name: "Группа А" },
      { id: 2, name: "Группа Б" },
      { id: 3, name: "Группа C" },
    ]);
    setTeachers([
      { id: 1, name: "Иванов И.И." },
      { id: 2, name: "Сидоров С.С." },
      { id: 3, name: "Петров П.П." },
    ]);
    setOffices([
      { id: 1, name: "205к" },
      { id: 2, name: "206к" },
      { id: 3, name: "207к" },
    ]);
    setSubjects([
      { id: 1, name: "Математика" },
      { id: 2, name: "Физика" },
      { id: 3, name: "Химия" },
    ]);
  }, []);

  const handleCellChange = (groupId, timeSlotId, field, value) => {
    setScheduleData(prevData => ({
      ...prevData,
      [groupId]: {
        ...prevData[groupId],
        [timeSlotId]: {
          ...prevData[groupId]?.[timeSlotId],
          [field]: value,
        },
      },
    }));
  };

  const renderSelect = (groupId, timeSlotId, field, options) => {
    return (
      <Select
        size="small"
        sx={{
          fontSize: "10px",
          width: "120px", // Уменьшаем ширину
        }}
        value={scheduleData[groupId]?.[timeSlotId]?.[field] || ""}
        onChange={e =>
          handleCellChange(groupId, timeSlotId, field, e.target.value)
        }>
        <MenuItem value="" disabled>
          {field}
        </MenuItem>
        {options.map(option => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    );
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Расписание
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Время</TableCell>
              {groups.map(group => (
                <TableCell key={group.id}>{group.name}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {timeSlots.map(slot => (
              <TableRow key={slot.id}>
                {/* Если это не первый столбец (время), то показываем расписание для группы */}
                {slot.time ? (
                  <>
                    <TableCell>{slot.time}</TableCell>
                    {groups.map(group => (
                      <TableCell key={`${group.id}-${slot.id}`}>
                        <Box display="flex" flexDirection="column" gap={1}>
                          {renderSelect(
                            group.id,
                            slot.id,
                            "subject_id",
                            subjects,
                          )}
                          {renderSelect(
                            group.id,
                            slot.id,
                            "office_id",
                            offices,
                          )}
                          {renderSelect(
                            group.id,
                            slot.id,
                            "teacher_id",
                            teachers,
                          )}
                        </Box>
                      </TableCell>
                    ))}
                  </>
                ) : (
                  // Если это день недели, то показываем только день
                  <TableCell colSpan={groups.length + 1}>{slot.day}</TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
